import OrderCostSummaryPdfV4 from "../OrderCostSummaryPdfV4";

const OrderCostSummaryPdfV5 = OrderCostSummaryPdfV4;

export default OrderCostSummaryPdfV5;
